
import { useState, useEffect } from 'react'

import TaskAltIcon from '@mui/icons-material/TaskAlt';

import ContactButton from '../components/contactbutton'


const NaasCard = ({ title, description, image, sliderLevel, selectedRange, included }) => {

    const [opacity, setOpacity] = useState(0)

    useEffect(() => {

        if (sliderLevel >= selectedRange.from && sliderLevel <= selectedRange.to) {
            setOpacity(100)
        } else {
            setOpacity(0)
        }
    }, [sliderLevel]);


    return (
        <>
            <div style={{ opacity: opacity }} className="rounded-xl absolute top-0 left-0 p-6 w-full h-full bg-white dark:text-white text-gray-600 dark:bg-gray-800">
                <div className="flex flex-row gap-4 w-full h-full">
                    <div className="flex flex-col gap-2 h-full sm:w-1/2 justify-between">
                        <h2 className="text-2xl">
                            Ace<span className="dark:text-sky-400 text-sky-500">{title.split('Ace')}</span>
                        </h2>

                        <div className="text-sx dark:text-gray-400 py-2">
                            {description}
                        </div>
                        <ul className="text-left">
                            {included.map((item, index) => (
                                <li key={index}> <TaskAltIcon sx={{ color: "green" }} /> {item}</li>
                            ))}
                        </ul>
                        <div className="">
                            <ContactButton>
                                Kontakta oss!
                            </ContactButton>
                        </div>
                    </div>
                    <div className="h-full sm:w-1/2 hidden sm:block">
                        <img className="rounded-md w-full h-full object-cover" src={image} />
                    </div>
                </div>
            </div>

        </>
    )
}


export default NaasCard;